import { computed } from 'mobx';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { resolve as urlResolve } from 'url';
import getStore from '../store/store';
var FAVICON_RELATIVE_PATH = 'resources/images/favicons';
var MAIL_SEEN_FAVICON = FAVICON_RELATIVE_PATH + "/mail-seen.ico";
var MAIL_UNSEEN_FAVICON = FAVICON_RELATIVE_PATH + "/mail-unseen.ico";
export default computed(function mailFaviconProvider() {
    if (getStore().unseenMessages === 0) {
        return getIconPath(MAIL_SEEN_FAVICON);
    }
    else {
        return getIconPath(MAIL_UNSEEN_FAVICON);
    }
});
function getIconPath(relativeUrl) {
    return urlResolve(getPackageBaseUrl(), relativeUrl);
}
//# sourceMappingURL=mailFaviconProvider.js.map